enum ChatGroupMessageStatus {
  Draft = 'Draft',
  Published = 'Published',
}

export default ChatGroupMessageStatus;
